import { Tokens } from '@tmov/design-system/theme/types';
import { Form } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CadastroForm = styled(Form)`
  width: 100%;
  min-height: 476px;
  min-width: 1000px;
  padding: 32px 56px;

  background: ${Tokens.eixods.colors.neutral.grey[0]};
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FormControls = styled.div`
  margin-top: 48px;
  gap: 32px;

  display: flex;
  justify-content: flex-end;
`;
